import { useEffect, type JSX } from 'react'
import { useLocation } from 'react-router-dom'
import { useConflict, useSetConflict } from '../../../data/selectors/app-config-selectors'
import ConflictDialog from './ConflictDialog'

/**
 * Renders the modification-conflict dialog and clears the (app-global) conflict
 * state whenever the route changes.
 *
 * The conflict state lives at the app level and is only reset when the user
 * clicks a dialog button. Without this, a conflict raised on one application
 * (or by a background request) persisted and re-appeared on top of a different
 * application the user later opened — showing "who/when" data unrelated to the
 * application on screen. Clearing on navigation scopes the dialog to the page
 * where the conflict actually occurred. (Bug 67353)
 */
const ConflictController = (): JSX.Element => {
  const conflict = useConflict()
  const setConflict = useSetConflict()
  const { pathname } = useLocation()

  useEffect(() => {
    setConflict(null)
  }, [pathname, setConflict])

  return <ConflictDialog open={conflict !== null} conflict={conflict} />
}

export default ConflictController
